import { Bone, SkeletonGrid, SkeletonCardTile } from '../primitives';

// Full-page version of AIVoicesV2.tsx for the hard-refresh case (App.js/RouteSkeleton),
// where none of the page's own chrome has mounted yet. Mirrors, top to bottom: the
// "Voices" title, the CreateVoiceWidget card (3 mode buttons), the Explore/My Voices/
// Bookmarks tabs, the search bar, the inline filter row, and the voice-card grid.
// The in-app loading state (once this chrome has already mounted) uses the lighter
// AIVoicesSkeleton for just the grid instead.
export default function AIVoicesPageSkeleton() {
    return (
        <div>
            {/* Title row */}
            <Bone h={24} w={100} style={{ marginBottom: 20 }} />

            {/* Create-voice widget card */}
            <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: 16, padding: 18, marginBottom: 20 }}>
                <SkeletonGrid cols={3} gap={10}>
                    {Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '13px 14px', border: '1.5px solid #E2E8F0', borderRadius: 12 }}>
                            <Bone w={38} h={38} r={10} />
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Bone h={13} w="70%" style={{ marginBottom: 6 }} />
                                <Bone h={10} w="90%" />
                            </div>
                        </div>
                    ))}
                </SkeletonGrid>
            </div>

            {/* Tabs */}
            <div style={{ display: 'flex', gap: 24, borderBottom: '1px solid #E2E8F0', marginBottom: 16, paddingBottom: 10 }}>
                <Bone h={14} w={60} />
                <Bone h={14} w={80} />
                <Bone h={14} w={90} />
            </div>

            {/* Search */}
            <Bone h={38} r={8} style={{ marginBottom: 8 }} />

            {/* Filter chips */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
                {Array.from({ length: 4 }).map((_, i) => <Bone key={i} h={38} w={100} r={8} />)}
            </div>

            {/* Voice card grid */}
            <SkeletonGrid cols={3} gap={12}>
                {Array.from({ length: 9 }).map((_, i) => (
                    <SkeletonCardTile key={i} hasImage={false} lines={2} />
                ))}
            </SkeletonGrid>
        </div>
    );
}
